<div class="mt-2 label-wrapper {{ bootstrap }} {{ containerClass }}" [ngClass]="{ 'pe-2': labelConfig.label }">
  <label
    *ngIf="labelConfig.label"
    class="{{ labelConfig.class }} label-padding font-size-{{ textSize }}"
    [ngClass]="{
      'data-label': !labelConfig.title,
      'data-title': labelConfig.title
    }">
    {{ labelConfig.label | translate }}
    <i *ngIf="info" [class]="appConfig.icon + ' fa-circle-info'" [pTooltip]="info"></i>
  </label>
  <div
    *ngIf="shouldShowContent()"
    [ngClass]="{
      stylish: labelConfig.type === 'STYLISH',
      light: light,
      'justify-content-center': center
    }"
    class="d-flex align-items-center h-100 mt-1">
    <p
      [ngClass]="{
        'data-link': labelConfig.href,
        'ps-2': labelConfig.label,
        'px-2': !labelConfig.label
      }"
      (click)="clickEvent ? onClick() : null"
      class="data-text m-0 font-size-{{ textSize }}">
      @if (labelConfig.value != undefined) { @if (labelConfig.currency) {
      {{ labelConfig.value ? (labelConfig.value | dynamicCurrency:labelConfig.currencyCodeOverride) : '-' }}
      } @else if (labelConfig.translate) { @if (labelConfig.isDiscontinued) {
      {{ 'shared.translate.isDiscontinued.' + labelConfig.value.toString().toLowerCase() | translate }}
      } @else {
      {{ 'shared.translate.' + labelConfig.value.toString().toLowerCase() | translate }}
      } } @else if (labelConfig.percentage) {
      {{ labelConfig.value ? labelConfig.value + '%' : '-' }}
      } @else {
      {{ labelConfig.value ? labelConfig.value : '-' }}
      } } @else {
      {{ '-' }}
      }
    </p>
  </div>

  <p-skeleton *ngIf="shouldShowSkeleton()" height="2rem" styleClass="mb-2" borderRadius="16px"></p-skeleton>
</div>
